import { Form, Select } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import { type BaseOptionType } from "antd/lib/select"
import React from "react"

import { type ProjectChecklistFilterOptions } from "../../../../../../redux/project.types.ts"
import type { ProjectChecklistItem } from "../../../../../../types/project-checklists.types.tsx"

interface ProjectViewChecklistsNewRowMilestonesProps {
  form: FormInstance<ProjectChecklistItem>
  options: ProjectChecklistFilterOptions
  projectTypeMilestonesMap: Map<string, BaseOptionType[]>
}

export function ProjectViewChecklistsNewRowMilestones({
  options,
  projectTypeMilestonesMap,
  form
}: ProjectViewChecklistsNewRowMilestonesProps) {
  const projectTypeID = Form.useWatch("project_type", form)

  const milestones = projectTypeID
    ? projectTypeMilestonesMap.get(projectTypeID) || []
    : options?.milestones

  return (
    <Form.Item<ProjectChecklistItem>
      name="project_phase"
      noStyle
      normalize={(value: string) => value || null}
    >
      <Select
        className="w-full"
        placeholder="Select milestone"
        options={milestones}
        showSearch
        allowClear
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input?.toLowerCase())
        }
      />
    </Form.Item>
  )
}
